import { useEffect, useState } from 'react';
import { getMode, setMode } from './theme.js';

const ICON = { auto: '🌗', light: '☀️', dark: '🌙' };
const NEXT = { auto: 'light', light: 'dark', dark: 'auto' };

export function ThemeToggle() {
  const [mode, setM] = useState(getMode());
  useEffect(() => {
    const h = () => setM(getMode());
    window.addEventListener('kapstat-theme', h);
    return () => window.removeEventListener('kapstat-theme', h);
  }, []);
  return (
    <button className="theme-toggle" title={`Theme: ${mode} (click to change)`} aria-label={`Theme: ${mode}, click to change`}
      onClick={() => { const n = NEXT[mode]; setMode(n); setM(n); }}>
      {ICON[mode]}
    </button>
  );
}
